import React from 'react';
import { Measurer } from '../../Measure';
import { Key } from '../Key';
import cls from '../../utils/classnames';
import {
    KEYBOARD_KEYSET,
    KEYBOARD_KEYSET_LINE,
    KEYBOARD_KEYSET_LINE_CENTERED,
    KEYBOARD_KEY_SHIFT_IMAGE,
    KEYBOARD_KEY_SPACE_IMAGE,
    KEYBOARD_KEY_SPACE_IMAGE_SEARCH,
    KEYBOARD_KEYSET_LINE_CENTERED_LAST_ROW,
    KEYBOARD_KEYSET_LINE_CENTERED_LAST_ROW_SEARCH
} from '../../utils/classes';

import './_styles.scss';
import { Keys } from '../types';
import { SHIFT, SPACE, GUION } from '../constants';
import Assets from '../../../../../requests/apa/Asset';
import store from 'src/store';

/**
 * <Keyset> props.
 */
export interface IKeysetProps {
    /**
     * The array of keys to render.
     */
    keyset: Keys;
    /**
     * A function to call when a key is clicked.
     *
     * @param value Value of the key.
     */
    onKeyClick(value: string): void;
    /**
     * True to center rows on the keyset.
     */
    centered?: boolean;
    /**
     * Flag to calculate the items size
     */
    calculateItemsSize?: boolean;
    itemWidth?: string;
    itemHeight?: string;
    paddingHorizontalItem?: string
    classNameItem?:string;
    isPay?: boolean;
}

/**
 * Displays a set of keys in a row with equidistant space between them.
 */
export const Keyset: React.FunctionComponent<IKeysetProps> = ({
    keyset,
    onKeyClick,
    centered = false,
    calculateItemsSize = true,
    itemWidth = '55px',
    itemHeight = '55px',
    paddingHorizontalItem = null,
    classNameItem = null,
    isPay
}) => {
    const length = Math.max.apply(
        null,
        keyset.map(keys => keys.length)
    );
    const classNames = isPay ? cls(KEYBOARD_KEYSET_LINE, { [KEYBOARD_KEYSET_LINE_CENTERED_LAST_ROW_SEARCH]: centered}) :
        keyset[0].find(element => element == GUION) ?
          cls(KEYBOARD_KEYSET_LINE, { [KEYBOARD_KEYSET_LINE_CENTERED_LAST_ROW]: centered}) :
          cls(KEYBOARD_KEYSET_LINE, { [KEYBOARD_KEYSET_LINE_CENTERED]: centered});

    const shift =  Assets.get('keyboard_access_option_button_shift', '');
    const space = Assets.get('keyboard_access_option_button_space', '');
    const path = window.location.pathname;
    const isPathSearchWithStyles = path.includes('search');

    const { isFlowSearcherForPin = false} = store.getState().searcher;

    const extraClassKey = isFlowSearcherForPin || isPathSearchWithStyles ? 'searcher' : '';

    return (
        <Measurer>
            {({ ref, dimensions }): JSX.Element => (
                <div ref={ref} className={KEYBOARD_KEYSET}>
                    {dimensions &&
                        keyset.map(keys => (
                            <div ref={ref} className={classNames}>
                                {keys.map((key, i) => {
                                    let style;
                                    if(calculateItemsSize){
                                        const size = Math.round(dimensions.width / length);
                                        if(keys.length !== 9) {
                                          style = { width: `${550 / keys.length}px`, height: size, paddingTop: '5px' };
                                        } else {
                                          style = { width: itemWidth, height: size, paddingTop: '5px', marginLeft: '6px' };
                                        }
                                    }
                                    else{
                                        style = { width: itemWidth, height: itemHeight };
                                    }
                                    if(paddingHorizontalItem){
                                        style = {...style, width: `${key.length * 10 + 10}px`, paddingLeft: '-5px' };
                                    }
                                  switch (key) {
                                    case SHIFT:
                                      return (
                                        <Key
                                          className={cls('focusable', 'border-radius-50')}
                                          style={style}
                                          key={i}
                                          onClick={onKeyClick}
                                          value={key}
                                        >
                                          <img className={KEYBOARD_KEY_SHIFT_IMAGE} src={shift} alt="shift" />
                                        </Key>
                                      );
                                    case SPACE:
                                      if(!calculateItemsSize){
                                        style = { width: 'auto', height: '55px' };
                                      }
                                      return (
                                        <Key
                                          className={cls('focusable', 'border-radius-5')}
                                          style={style}
                                          key={i}
                                          onClick={onKeyClick}
                                          value={' '}
                                        >
                                          <img className={KEYBOARD_KEY_SPACE_IMAGE_SEARCH} src={space} alt="space" />
                                        </Key>
                                      );
                                    default:
                                      return (
                                        <Key className={cls('focusable', classNameItem, extraClassKey)} style={style} key={i} onClick={onKeyClick}>
                                          {key as string}
                                        </Key>
                                      );
                                  }
                                })}
                            </div>
                        ))}
                </div>
            )}
        </Measurer>
    );
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/Keyboard/Keyset/index.tsx